import { render, staticRenderFns } from "./DocumentLayoutForm.vue?vue&type=template&id=4651ff69"
import script from "./DocumentLayoutForm.vue?vue&type=script&lang=js"
export * from "./DocumentLayoutForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentLayoutForm.vue?vue&type=style&index=0&id=4651ff69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports